import { styled } from '@mui/material'

const COUNTER_BADGE_SIZE = 22

export const Label = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}))

export const CounterBadge = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  minWidth: COUNTER_BADGE_SIZE,
  height: COUNTER_BADGE_SIZE,
  padding: theme.spacing(0, 0.75),
  borderRadius: COUNTER_BADGE_SIZE / 2,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1,
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,

  '.Mui-selected &': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}))
